// TODO(@claudio): Merge this component with src/ui/tabs.tsx and update to use the latest shadcn/ui "tabs" version.
import { CSSProperties, FC } from "react";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

type ButtonProps = {
  state: "default" | "inactive";
  text: string;
  onClick?: () => void;
  onGray?: boolean;
  buttonWidth?: string;
  dataTestId?: string;
};

const ELEVATION_1_SHADOW =
  "0px 0px 2px rgba(142, 145, 146, 0.3), 0px 0px 3px 1px rgba(142, 145, 146, 0.15)";

const SegmentedControlButton: FC<ButtonProps> = ({
  state,
  text,
  onClick,
  onGray,
  buttonWidth,
  dataTestId,
}) => {
  const isDefault = state === "default";
  const isInactive = state === "inactive";

  return (
    <button
      style={{
        width: buttonWidth,
        boxShadow: isDefault ? ELEVATION_1_SHADOW : undefined,
      }}
      className={cn(
        "flex-1 inline-flex justify-center items-center rounded-md px-3 border-none cursor-pointer",
        isDefault && "bg-white",
        isInactive && (onGray ? "bg-gray-1" : "bg-gray-1"),
      )}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <Text
        variant="compact-title"
        className={isDefault ? "text-black" : "text-gray-7"}
      >
        {text}
      </Text>
    </button>
  );
};

interface Option<T extends string> {
  value: T;
  label: string;
  dataTestId?: string;
}

interface Props<T extends string> {
  selectedOption: T;
  options: Option<T>[];
  onOptionSelected?: (option: T) => void;
  onGray?: boolean;
  style?: CSSProperties;
  className?: string;
  buttonWidth?: string;
}

const SegmentedControl = <T extends string>({
  options,
  selectedOption,
  onOptionSelected,
  onGray,
  style,
  className,
  buttonWidth,
}: Props<T>): React.ReactElement => {
  return (
    <div
      style={style}
      className={cn(
        "inline-flex flex-row h-9 p-0.5 gap-0.5 bg-gray-1 rounded-lg box-border flex-shrink-0 w-full",
        className,
      )}
    >
      {options.map((option) => (
        <SegmentedControlButton
          key={`${option.value}-${option.label}`}
          state={option.value === selectedOption ? "default" : "inactive"}
          text={option.label}
          onClick={
            onOptionSelected ? () => onOptionSelected(option.value) : undefined
          }
          onGray={onGray}
          buttonWidth={buttonWidth}
          dataTestId={option.dataTestId}
        />
      ))}
    </div>
  );
};

export default SegmentedControl;
